import { connect } from "react-redux";

import makeRoot from "../components/make_root";

const mapStateToProps = state => {
  const searchIsBeingSaved = !!state.savedSearches.searchIsBeingSaved;

  return { searchIsBeingSaved };
};

const mapDispatchToProps = () => ({
});

export default (FilterBox, Breadcrumbs, MainView) => {
  const Root = makeRoot(FilterBox, Breadcrumbs, MainView);
  return connect(mapStateToProps, mapDispatchToProps)(Root);
};
